import { ID, Response } from "../../../../../_metronic/helpers"

// import {ID, Response} from '../../../../../../_metronic/helpers'
export type Floor = {
  id?: ID
  name?: string
  avatar?: string
  email?: string
  mobile?: string
  role?: string
  dob?: string
  position?: string
  appartment?: String
  floor_info?: string
  two_steps?: boolean
  property_info?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }
}

export type FloorsQueryResponse = Response<Array<Floor>>

export const initialFloor: Floor = {
  avatar: 'avatars/300-6.jpg',
   position: 'Art Director',
   role: 'Administrator',
  name: '',
  email: '',
}
